import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ModulesVM } from './modules.viewmodel';
import { ModulesList } from './_modules-list/modules-list';
import { ModuleTypePicker } from './module-type-picker/module-type-picker';
import { ModuleModalHost } from './module-modal-host';
import { InactiveModulesSection } from './_inactive-modules-section/inactive-modules-section';
import { MODULES_SECTION_LABEL_TEXT } from '../../../../../event-hubs.text';
import { hasPermission } from '../../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../../api/roles.dao';
import './modules-section.scss';

type ModulesSectionProps = {
    vm: ModulesVM;
};

export const ModulesSection: React.FC<ModulesSectionProps> = observer(({ vm }) => {
    const canManage = hasPermission(Permission.HUB_MANAGE_PAGES_AND_MODULES);
    const editingModuleVM = vm.getEditingModuleVM();
    const hasInactiveModules = vm.inactiveModules.length > 0;

    return (
        <div className='modules-section'>
            <div className='modules-section__header'>
                <FormattedMessage {...MODULES_SECTION_LABEL_TEXT} />
            </div>
            <ModulesList vm={vm} canManage={canManage} />
            {canManage && (
                <ModuleTypePicker
                    className={classnames('modules-section__add-module', {
                        'modules-section__add-module--no-divider': hasInactiveModules,
                    })}
                    isOpen={vm.isModuleTypePickerOpen()}
                    onOpen={vm.openModuleTypePicker}
                    onClose={vm.closeModuleTypePicker}
                    onSelect={vm.addModule}
                />
            )}
            <InactiveModulesSection vm={vm} canManage={canManage} />
            {editingModuleVM && (
                <ModuleModalHost
                    vm={editingModuleVM}
                    isNew={vm.isAddingModule()}
                    onCancel={vm.cancelEditingModule}
                    onConfirm={vm.confirmEditingModule}
                />
            )}
        </div>
    );
});
